// extracted by mini-css-extract-plugin
export default {"info":"delete-location_info__JPDYY","text":"delete-location_text__AdxVP","source":"delete-location_source__jYh5W","button":"delete-location_button__bDuiU"};